import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Public, AccountTree, PendingActions, Map, Layers } from "@mui/icons-material";

// Casca compartilhada das 4 telas de "Geografia" (Mapa de Pesca, Locais de
// Pesca, Pendências de Local, Áreas de Pesca) — antes eram 4 itens
// separados no sidebar, agora é 1 item só levando pra cá, com abas no topo
// pra trocar entre as telas. As URLs de cada tela continuam as mesmas de
// antes (nada de link/bookmark quebra) — só ganharam essa barra por cima.
const GeografiaLayout = () => {
  const isAdmin = localStorage.getItem('modulo') === 'admin';

  const abas = [
    { name: 'Mapa de Pesca', path: '/admin/locais/mapa', icon: <Public fontSize="small" />, end: true },
    ...(isAdmin ? [{ name: 'Locais de Pesca', path: '/admin/locais', icon: <AccountTree fontSize="small" />, end: true }] : []),
    ...(isAdmin ? [{ name: 'Pendências de Local', path: '/admin/locais/pendencias', icon: <PendingActions fontSize="small" />, end: true }] : []),
    ...(isAdmin ? [{ name: 'Importar Geometria', path: '/admin/locais/importar-geometria', icon: <Layers fontSize="small" />, end: true }] : []),
    { name: 'Áreas de Pesca', path: '/admin/areas', icon: <Map fontSize="small" />, end: true },
  ];

  return (
    <div style={{ width: '100%' }}>
      <div style={tabBarWrapStyle}>
        <div style={tabBarStyle}>
          {abas.map((aba) => (
            <NavLink
              key={aba.path}
              to={aba.path}
              end={aba.end}
              style={({ isActive }) => ({ ...tabStyle, ...(isActive ? tabActiveStyle : {}) })}
            >
              {aba.icon}
              {aba.name}
            </NavLink>
          ))}
        </div>
      </div>
      {/* min-height fixo — sem isso a página "pula" de tamanho ao trocar de
          aba (Pendências vazia é bem mais baixa que Mapa de Pesca, por
          exemplo), o que incomoda em quem usa o sistema o dia todo. */}
      <div style={{ minHeight: '78vh' }}>
        <Outlet />
      </div>
    </div>
  );
};

const tabBarWrapStyle: React.CSSProperties = {
  width: '100%', maxWidth: '1200px', margin: '0 auto', padding: '20px 20px 0',
};
const tabBarStyle: React.CSSProperties = {
  display: 'flex', gap: '4px', borderBottom: '1px solid #e2e2e2', flexWrap: 'wrap',
};
const tabStyle: React.CSSProperties = {
  display: 'flex', alignItems: 'center', gap: '6px',
  padding: '10px 16px', fontSize: '0.88rem', color: '#666', textDecoration: 'none',
  borderBottom: '2px solid transparent', marginBottom: '-1px', whiteSpace: 'nowrap',
};
const tabActiveStyle: React.CSSProperties = {
  color: 'var(--green-700, #00b37e)', borderBottomColor: 'var(--green-700, #00b37e)', fontWeight: 600,
};

export default GeografiaLayout;
